import { render, staticRenderFns } from "./TabData.vue?vue&type=template&id=44f22634&"
import script from "./TabData.vue?vue&type=script&lang=js&"
export * from "./TabData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports